export const createGameModeSlice = ({ initialGameModeData })=>(set, get)=>({
            gameMode: {
                activeResourceCardTypes: initialGameModeData.activeResourceCardTypes,
                activeDevelopmentAndProgressCardTypes: initialGameModeData.activeDevelopmentCardTypes,
                /**
         * @deprecated Use useUIGameTranslationContext instead
         */ translationKeyContext: initialGameModeData.translationKeyContext
            }
        });
